import { RatesWidget } from '@/app_components/common/widgets/RatesWidget/RatesWidget';
import { RedVentureWidgets } from '@/app_data/widgets/RedVentures/constants';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';

export const embedRatesWidgets = (): ParserRule => ({
  insertComponent: ({ node }) => {
    switch (node.props['data-ad-id']) {
      case RedVentureWidgets.CdRates: {
        return <RatesWidget type='CD' />;
      }
      case RedVentureWidgets.SavingsMma: {
        return <RatesWidget type='Savings' />;
      }
      default:
        return <></>;
    }
  },
  insertPosition: 'replace',
  match: ({ node }) =>
    node.props?.['data-ad-id'] &&
    [RedVentureWidgets.CdRates, RedVentureWidgets.SavingsMma].includes(node.props['data-ad-id']),
});
